import { type ReactNode } from "react";

import { Label } from "@/components/ui/label";
import { cn } from "@/lib/utils";

interface RepresentativeFormFieldProps {
  id: string;
  label: string;
  children: ReactNode;
  errorMessage?: string;
  required?: boolean;
  className?: string;
}

export const RepresentativeFormField = ({
  id,
  label,
  children,
  errorMessage,
  required = false,
  className,
}: RepresentativeFormFieldProps) => (
  <div className={cn("space-y-2", className)}>
    <Label htmlFor={id} className="font-semibold text-foreground">
      {label}
      {required && (
        <span aria-hidden="true" className="ml-0.5 text-destructive">
          *
        </span>
      )}
    </Label>
    {children}
    {errorMessage ? (
      <p id={`${id}-error`} role="alert" className="text-destructive text-sm">
        {errorMessage}
      </p>
    ) : null}
  </div>
);
